'use strict'

import { tns } from "tiny-slider/src/tiny-slider";

const blocImages = {
    init() {
        if (document.querySelector('.bloc-images__container')) {
            const slider = tns({
                container: '.bloc-images__wrapper',
                controlsContainer: document.querySelector('.bloc-images_controls'),
                disable: false,
                center: true,
                items: 1.2,
                slideBy: 1,
                nav: false,
                gutter: 25,
                loop: false,
                responsive: {
                    767: {
                        disable: true,
                    }
                }
            });
        }
    }
}

export default blocImages;


// WEBPACK FOOTER //
// ./src/scripts/components/blocImages.js